module.exports = __webpack_public_path__ + "static/media/6.b5653a43.jpg";